import { SWITCH_CONSTANTS } from './switch-constants';
var SwitchFoundation = /** @class */ (function () {
    function SwitchFoundation(_adapter) {
        var _this = this;
        this._adapter = _adapter;
        this._dense = false;
        this._handleChange = function () { return _this._handleInputChange(); };
    }
    SwitchFoundation.prototype.disconnect = function () {
        this._adapter.unlisten('change', this._handleChange);
        this._adapter.disconnect();
        this._adapter.uninstallPropertyChangeHooks();
    };
    SwitchFoundation.prototype.connect = function () {
        var _this = this;
        this._adapter.initialize();
        this._adapter.setDense(this._dense);
        this._updateDisabledStyles();
        this._updateCheckedStyles();
        this._inputAttributeChangedListener = function () { return _this._updateDisabledStyles(); };
        this._adapter.setInputAttributeObserver(function () { return _this._inputAttributeChangedListener(); });
        this._adapter.listen('change', this._handleChange);
        this._adapter.installPropertyChangeHooks(this._handleChange);
    };
    Object.defineProperty(SwitchFoundation.prototype, "dense", {
        get: function () {
            return this._dense;
        },
        set: function (value) {
            if (this._dense !== value) {
                this._dense = value;
                this._adapter.setDense(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    SwitchFoundation.prototype._handleInputChange = function () {
        this._updateCheckedStyles();
    };
    SwitchFoundation.prototype._updateDisabledStyles = function () {
        if (this._adapter.isDisabled()) {
            this._adapter.setRootClass(SWITCH_CONSTANTS.classes.DISABLED);
        }
        else {
            this._adapter.removeRootClass(SWITCH_CONSTANTS.classes.DISABLED);
        }
    };
    SwitchFoundation.prototype._updateCheckedStyles = function () {
        var ARIA_CHECKED_ATTR = SWITCH_CONSTANTS.strings.ARIA_CHECKED_ATTR;
        // Ensure aria-checked is set to mixed if switch is in indeterminate state.
        if (this._adapter.isChecked()) {
            this._adapter.setNativeAttribute(ARIA_CHECKED_ATTR, 'true');
            this._adapter.setRootClass(SWITCH_CONSTANTS.classes.CHECKED);
        }
        else {
            // The on/off state does not need to keep track of aria-checked, since
            // the screenreader uses the checked property on the switch element.
            this._adapter.removeNativeAttribute(ARIA_CHECKED_ATTR);
            this._adapter.removeRootClass(SWITCH_CONSTANTS.classes.CHECKED);
        }
    };
    return SwitchFoundation;
}());
export { SwitchFoundation };
